module.exports = __webpack_public_path__ + "static/media/four_seasons.70fd05d0.png";